import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { getEnvironment } from './constants/ApiConstants';

const rootEl = document.getElementById('app-site');

const env = getEnvironment();

Sentry.init({
  dsn: 'https://a3995c41fd3e4fde801b8215ff5789d7@o333392.ingest.sentry.io/5996857',
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  environment: env,
});

// Create a reusable render method that we can call more than once
let render = () => {
  // Dynamically import our main App component, and render it
  const MainApp = require('./MainApp').default;
  ReactDOM.render(<MainApp />, rootEl);
};

if (module.hot) {
  module.hot.accept('./MainApp', () => {
    const NextApp = require('./MainApp').default;
    render(<NextApp />, rootEl);
  });
}

render();



// WEBPACK FOOTER //
// ./index.js